/* feela. AI Personal Advisor — 過去のワンページLPの custom-liquid（custom_liquid_pkQzMk）から移植。
   variant ID 51848236335385/51848236368153/51943115915545 が現在の
   ブラック ミディアム/ソフト/ハード と一致することを 2026-09-03 に商品データで確認済み。
   2026-09-05 に advisor 由来の購入処理だけを、多重送信・通信結果不明・商品取得失敗時に安全に停止する実装へ更新。 */
(function(){
  if(window.FeelaAdvisor && window.FeelaAdvisor.isReady){
    var _r=document.getElementById('flAdvInlineRoot');
    if(_r && !_r._feelaMounted){ _r._feelaMounted=true; window.FeelaAdvisor.mount(_r,{source:'inline'}); }
    return;
  }

  
  var COPY = {

    
    scene1_confirm: {
      ai: [
        'あなたにおすすめの硬さは「{tier}」です。',
        'この硬さを選びますか？'
      ],
      options: [
        { value: 'confirm', label: 'この{tier}で進める', primary: true },
        { value: 'compare', label: '他の硬さが気になる' }
      ]
    },

    
    scene1b_compare: {
      ai: [
        'もちろんです。3つの硬さの特徴をご紹介します。',
        '気になる硬さをお選びください。'
      ],
      cards: {
        soft:   { desc: '包み込まれるような優しいフィット感。柔らかさで身体の緊張をリセットします。' },
        medium: { desc: '理想的な支持力と快適性のバランス。長時間でも疲れにくい黄金比の硬さです。' },
        hard:   { desc: '身体の軸を支える盤石の安定感。姿勢の崩れをしっかり防ぎます。' }
      },
      recommendBadge: 'あなたへのおすすめ',
      btnSelect: 'これを選ぶ'
    },

    
    scene2_color: {
      ai: [
        'ありがとうございます。'
      ],
      
      afterSelect: [
        '全国送料無料です。',
        '30日間の返品が可能です。',
        'ご準備が整いました。'
      ]
    },

    
    scene4_atc: {
      productName: 'feela. 整体エルゴクッション',
      tierLabel: 'YOUR PICK',
      priceNote: '税込・全国送料無料',
      btnATC: 'カートに追加',
      btnATCLoading: '処理中…',
      btnATCSoldOut: '現在在庫切れ',
      altLink: '← 硬さを選び直す'
    }

  };
  

  
  function t(text, vars){
    vars = vars || {};
    return String(text).replace(/\{(\w+)\}/g, function(_, k){
      return vars[k] != null ? vars[k] : '';
    });
  }

  
  var _earlyBuf = [], _earlyFlushed = false;
  function flushEarly(){
    if(_earlyFlushed) return; _earlyFlushed = true;
    _earlyBuf.forEach(function(ev){ track(ev.n, ev.p); });
    _earlyBuf.length = 0;
  }
  setTimeout(flushEarly, 6000);
  window.addEventListener('load', function(){ setTimeout(flushEarly, 5500); });
  function track(name, params){
    params = Object.assign({ event_category:'advisor' }, params || {});
    try{ if(window.debugSeatLpExistingEvent) window.debugSeatLpExistingEvent('advisor_'+name,params); }catch(e){}
    try{ if(window.gtag) window.gtag('event','advisor_'+name,params); }catch(e){}
    try{ if(window.clarity) window.clarity('event','advisor_'+name); }catch(e){}
    try{ if(window.fbq) window.fbq('trackCustom','Advisor_'+name,params); }catch(e){}
  }
  function fireTrack(name, params){
    if(!window.gtag && !window.clarity && !window.fbq){ _earlyBuf.push({n:name,p:params}); }
    track(name, params);
  }

  var QUESTIONS = [
    {
      id:'weight',
      ai:['こんにちは。私は feela. のパーソナルAIアドバイザーです。','あなたにぴったりの硬さを、6つの質問から一緒に見つけます。','まずはじめに、体重の目安を教えてください。'],
      options:[{value:48,label:'〜50kg'},{value:55,label:'51〜60kg'},{value:65,label:'61〜70kg'},{value:75,label:'71〜80kg'},{value:83,label:'81〜100kg'},{value:100,label:'100kg〜'}],
      scoreMode:'raw'
    },
    {
      id:'preference',
      ai:['ありがとうございます。普段の座り心地の好みはありますか？'],
      options:[{value:'soft',label:'柔らかめが好き',score:-10},{value:'medium',label:'普通・わからない',score:0},{value:'hard',label:'硬めが好き',score:10}]
    },
    {
      id:'pressure',
      ai:['お尻への圧迫感は気になりやすい方ですか？'],
      options:[{value:'concerned',label:'気になる(痺れやすい)',score:-10},{value:'none',label:'特に気にならない',score:0}]
    },
    {
      id:'usage',
      ai:['主な使用シーンを教えてください。'],
      options:[{value:'デスクワーク',label:'デスクワーク',score:10},{value:'運転・移動',label:'運転・長時間移動',score:5},{value:'自宅でリラックス',label:'自宅でのリラックス',score:-10},{value:'介護用',label:'介護用',score:-10}],
      storeText:'usageText'
    },
    {
      id:'age',
      ai:['ご自身の年代を教えてください。'],
      options:[{value:'young',label:'〜59歳',score:0},{value:'middle',label:'60〜74歳',score:-5},{value:'senior',label:'75歳〜',score:-10}]
    },
    {
      id:'worry',
      ai:['もう少しです。','今、最も解決したいお悩みはどれですか？'],
      options:[
        {value:'しびれ・違和感',label:'お尻〜脚の違和感・しびれ',score:-10},
        {value:'腰の重だるさ',label:'腰の重だるさ・姿勢の崩れ',score:5},
        {value:'底付き・沈み込み',label:'沈み込みすぎるのが不安',score:10},
        {value:'特になし',label:'特になし',score:0}
      ],
      storeText:'worryText'
    }
  ];

  var TIER_LABEL = {soft:'ソフト',medium:'ミディアム',hard:'ハード'};
  var TIER_SUB   = {soft:'(包み込まれるような優しいフィット感)',medium:'(理想的な支持力と快適性のバランス)',hard:'(身体の軸を支える盤石の安定感)'};
  var COLOR_LABEL = {black:'ブラック'};
  var SCENE_ADVICE = {
    'デスクワーク':'長時間の集中が必要なデスクワークでも、思考を妨げない安定した姿勢をサポートします。',
    '運転・移動':'運転中の座面の揺れや微細な振動に対しても、身体の軸をピタッと安定させます。',
    '自宅でリラックス':'ソファのような安らぎを椅子の上で再現し、身体の緊張を完全にリセットします。',
    '介護用':'体圧を均等に分散し、長時間の使用でも身体への負担を最小限に抑えます。'
  };
  var SOLUTION = {
    soft:{'しびれ・違和感':'最も除圧効果の高い<em>「ソフト」</em>が最適です。神経圧迫を極限まで抑え、筋肉の緊張をリセットします。','腰の重だるさ':'身体を優しく包み込み、筋肉の緊張を解きほぐす<em>「ソフト」</em>がおすすめです。リラックスして座ることで腰の負担を和らげる、ゆとりのある座り心地です。','底付き・沈み込み':'軽量な体格のあなたなら過度な沈み込みの心配はありません。<em>「ソフト」</em>の包み込まれる心地よさを存分にお楽しみいただけます。','default':'あなたの体格に最も馴染む<em>「ソフト」</em>がおすすめです。'},
    medium:{'しびれ・違和感':'支持力と除圧を両立した黄金比<em>「ミディアム」</em>がおすすめです。','腰の重だるさ':'骨盤を理想的な角度でホールドする<em>「ミディアム」</em>がおすすめです。崩れがちな姿勢を根本から支え、腰の負担を解消します。','底付き・沈み込み':'高密度ウレタンが体重を確実に支える<em>「ミディアム」</em>がおすすめです。','default':'最もバランスに優れた<em>「ミディアム」</em>がおすすめです。'},
    hard:{'しびれ・違和感':'高密度ウレタンで底付きによる間接圧迫を防ぐ<em>「ハード」</em>がおすすめです。体重をしっかり面で受け止め、神経圧迫の原因となる過度な沈み込みを回避します。','腰の重だるさ':'身体の軸を揺るがせない<em>「ハード」</em>がおすすめです。筋肉に頼らず骨格で座れる感覚で腰の疲れを完封します。','底付き・沈み込み':'沈み込みを徹底的に抑える最高密度の<em>「ハード」</em>がおすすめです。クッション内部で底まで届かない、確かな支持力を実感できます。','default':'圧倒的な支持力を誇る<em>「ハード」</em>がおすすめです。'}
  };
  var vidMap = {'soft-black':'51848236368153','medium-black':'51848236335385','hard-black':'51943115915545'};
  var PRODUCT_HANDLE = 'feela-整体エルゴクッション';
  var IMG_BLACK = 'https://cdn.shopify.com/s/files/1/0556/1489/8457/files/01a_main-image_color.webp?v=1779347814';
  var PRODUCT_URL = 'https://feela.co.jp/products/feela-%E6%95%B4%E4%BD%93%E3%82%A8%E3%83%AB%E3%82%B4%E3%82%AF%E3%83%83%E3%82%B7%E3%83%A7%E3%83%B3';
  var productCache = null;
  var productRequest = null;
  var ATC_TIMEOUT_MS = 12000;
  function fetchProduct(){
    if(productCache) return Promise.resolve(productCache);
    if(productRequest) return productRequest;
    productRequest = fetch('/products/'+encodeURIComponent(PRODUCT_HANDLE)+'.js',{
      headers:{'Accept':'application/json'},credentials:'same-origin',cache:'no-store'
    }).then(function(r){
      if(!r.ok) throw new Error('product_fetch_failed');
      return r.json();
    }).then(function(d){
      if(!d||!Array.isArray(d.variants)) throw new Error('product_response_invalid');
      productCache=d;
      productRequest=null;
      return d;
    }).catch(function(error){
      productRequest=null;
      throw error;
    });
    return productRequest;
  }
  function fmtPrice(c){ return '¥'+Math.floor(c/100).toLocaleString('ja-JP'); }

  function verifiedVariant(tier,color){
    if(!productCache||!Array.isArray(productCache.variants))return null;
    var expectedId=parseInt(vidMap[tier+'-'+color],10);
    if(!expectedId)return null;
    for(var i=0;i<productCache.variants.length;i++){
      if(Number(productCache.variants[i].id)===expectedId)return productCache.variants[i];
    }
    return null;
  }

  function cartQuantity(cart,variantId){
    if(!cart||!Array.isArray(cart.items))throw new Error('cart_response_invalid');
    var quantity=0;
    for(var i=0;i<cart.items.length;i++){
      var itemId=Number(cart.items[i].variant_id||cart.items[i].id);
      if(itemId===Number(variantId))quantity+=Number(cart.items[i].quantity)||0;
    }
    return quantity;
  }

  function readCartQuantity(variantId){
    return fetch('/cart.js',{
      method:'GET',headers:{'Accept':'application/json'},credentials:'same-origin',cache:'no-store'
    }).then(function(res){
      if(!res.ok)throw new Error('cart_read_failed');
      return res.json();
    }).then(function(cart){return cartQuantity(cart,variantId);});
  }

  function cartAddError(kind,message,ambiguous){
    var error=new Error(message||kind);
    error.kind=kind;
    error.ambiguous=!!ambiguous;
    return error;
  }

  function requestCartAdd(variantId){
    return new Promise(function(resolve,reject){
      var settled=false;
      var controller=typeof AbortController==='function'?new AbortController():null;
      var timer=setTimeout(function(){
        if(settled)return;
        settled=true;
        if(controller)controller.abort();
        reject(cartAddError('timeout','timeout',true));
      },ATC_TIMEOUT_MS);

      function finish(fn,value){
        if(settled)return;
        settled=true;
        clearTimeout(timer);
        fn(value);
      }

      var options={
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        credentials:'same-origin',
        body:JSON.stringify({items:[{id:Number(variantId),quantity:1}]})
      };
      if(controller)options.signal=controller.signal;

      fetch('/cart/add.js',options).then(function(res){
        return res.text().then(function(body){
          var data=null;
          try{data=JSON.parse(body);}catch(e){}
          if(!res.ok||(data&&data.status)){
            var status=Number((data&&data.status)||res.status)||0;
            var message=(data&&(data.description||data.message))||'カートに追加できませんでした。';
            finish(reject,cartAddError('http',message,status>=500||status===0));
            return;
          }
          if(!data||!Array.isArray(data.items)){
            finish(reject,cartAddError('invalid_response','invalid_response',true));
            return;
          }
          var matched=false;
          for(var i=0;i<data.items.length;i++){
            if(Number(data.items[i].variant_id||data.items[i].id)===Number(variantId)&&Number(data.items[i].quantity)>=1){
              matched=true;
              break;
            }
          }
          if(!matched){
            finish(reject,cartAddError('invalid_response','invalid_response',true));
            return;
          }
          finish(resolve,data);
        }).catch(function(){
          finish(reject,cartAddError('invalid_response','invalid_response',true));
        });
      }).catch(function(error){
        if(settled)return;
        finish(reject,cartAddError(
          error&&error.name==='AbortError'?'timeout':'network',
          error&&error.message,
          true
        ));
      });
    });
  }

  var AI_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/><circle cx="12" cy="12" r="3"/></svg>';
  function mk(tag,cls,html){ var e=document.createElement(tag); if(cls)e.className=cls; if(html!=null)e.innerHTML=html; return e; }
  function scrollBot(el){ requestAnimationFrame(function(){ el.scrollTo?el.scrollTo({top:el.scrollHeight,behavior:'smooth'}):(el.scrollTop=el.scrollHeight); }); }

  function scrollToResultTop(rootEl){
    rootEl.scrollTop = 0;
    var panelEl = rootEl.parentNode;
    if(!panelEl) return;
    requestAnimationFrame(function(){
      var rect = panelEl.getBoundingClientRect();
      var headerOffset = 40;
      if(rect.top < headerOffset || rect.top > window.innerHeight * 0.4){
        var targetY = Math.max(0, window.pageYOffset + rect.top - headerOffset);
        if(window.scrollTo){
          try{ window.scrollTo({top: targetY, behavior:'smooth'}); }
          catch(e){ window.scrollTo(0, targetY); }
        } else {
          document.documentElement.scrollTop = targetY;
          document.body.scrollTop = targetY;
        }
      }
    });
  }

  function typewriter(bubble,text,speed,done){
    speed=speed||25; var i=0,finished=false;
    var caret=mk('span','fl-adv-bubble__caret');
    var tn=document.createTextNode('');
    bubble.appendChild(tn); bubble.appendChild(caret);
    var timer=null;
    function finish(){
      if(finished)return; finished=true;
      tn.nodeValue=text;
      if(caret.parentNode)caret.parentNode.removeChild(caret);
      clearTimeout(timer); done&&done();
    }
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      finish();
      return;
    }
    function step(){ if(finished)return; i++; tn.nodeValue=text.slice(0,i); if(i>=text.length){finish();return;} timer=setTimeout(step,speed+Math.random()*15); }
    timer=setTimeout(step,80);
    bubble.addEventListener('click',finish);
  }
  function typingInd(){
    var n=mk('div','fl-adv-msg fl-adv-msg--ai');
    n.innerHTML='<div class="fl-adv-avatar">'+AI_SVG+'</div><div class="fl-adv-bubble" style="padding:4px 8px!important;"><div class="fl-adv-typing"><span class="fl-adv-typing__dot"></span><span class="fl-adv-typing__dot"></span><span class="fl-adv-typing__dot"></span></div></div>';
    return n;
  }
  function advisorNeedsLabel(chat){
    var node=chat.lastElementChild;
    while(node){
      if(node.classList&&node.classList.contains('fl-adv-msg--user'))return true;
      if(node.classList&&node.classList.contains('fl-adv-msg--ai'))return false;
      node=node.previousElementSibling;
    }
    return true;
  }
  function advisorLabel(){
    var label=mk('div','fl-adv-speaker');
    label.innerHTML='<span class="fl-adv-speaker__brand">feela<span class="fl-adv-speaker__dot">.</span></span>';
    return label;
  }
  function addAI(chat,text,speed,done,ui){
    ui=ui||{};
    var showSpeaker=ui.speaker!==false&&advisorNeedsLabel(chat);
    var cls='fl-adv-msg fl-adv-msg--ai'+(showSpeaker?' fl-adv-msg--speaker':'')+(ui.question?' fl-adv-msg--question':'');
    var w=mk('div',cls);
    if(showSpeaker)w.appendChild(advisorLabel());
    var avatar=mk('div','fl-adv-avatar',AI_SVG); w.appendChild(avatar);
    var b=mk('div','fl-adv-bubble'); w.appendChild(b); chat.appendChild(w);
    scrollBot(chat.parentNode||chat);
    typewriter(b,text,speed,function(){ scrollBot(chat.parentNode||chat); done&&done(); });
  }
  function addUser(chat,text){
    var w=mk('div','fl-adv-msg fl-adv-msg--user'); w.innerHTML='<div class="fl-adv-bubble"></div>'; w.firstChild.textContent=text; chat.appendChild(w); scrollBot(chat.parentNode||chat);
  }
  function addOptions(chat,opts,onPick,layout){
    var box=mk('div','fl-adv-options'+(layout?' fl-adv-options--'+layout:''));
    opts.forEach(function(opt){
      var cls = 'fl-adv-opt-btn' + (opt.primary ? ' fl-adv-opt-btn--primary' : '');
      var b=mk('button',cls); b.type='button'; b.textContent=opt.label;
      b.addEventListener('click',function(){
        b.classList.add('is-selected');
        box.classList.add('is-answered');
        box.style.pointerEvents='none';
        box.style.opacity='.5';
        onPick(opt);
      });
      box.appendChild(b);
    });
    chat.appendChild(box); scrollBot(chat.parentNode||chat); return box;
  }
  function playLines(chat,lines,done){
    var i=0;
    function next(){
      if(i>=lines.length){ done&&done(); return; }
      var ind=typingInd(); chat.appendChild(ind); scrollBot(chat.parentNode||chat);
      setTimeout(function(){
        chat.removeChild(ind);
        addAI(chat,lines[i],24,function(){ i++; setTimeout(next,250); });
      },500+Math.random()*400);
    }
    next();
  }

  function playQuestion(chat,q,current,total,done){
    var intro=q.ai.slice(0,-1);
    var question=q.ai[q.ai.length-1];
    function showQuestion(){
      var progress=mk('div','fl-adv-progress');
      progress.textContent=current+' / '+total;
      chat.appendChild(progress);
      scrollBot(chat.parentNode||chat);
      var ind=typingInd(); chat.appendChild(ind); scrollBot(chat.parentNode||chat);
      setTimeout(function(){
        chat.removeChild(ind);
        addAI(chat,question,24,function(){done&&done(progress);},{question:true});
      },500+Math.random()*400);
    }
    if(intro.length)playLines(chat,intro,showQuestion);
    else showQuestion();
  }

  function calcResult(s){
    var t=(s.weight||65)+(s.preference||0)+(s.pressure||0)+(s.usage||0)+(s.age||0)+(s.worry||0);
    var tier=t<=60?'soft':t<=89?'medium':'hard';
    if(tier==='soft'&&s.preference===10)tier='medium';
    if(tier==='soft'&&s.worry===10)tier='medium';
    return{total:t,tier:tier};
  }

  function mount(rootEl,opts){
    if(!rootEl||rootEl._flMounted)return;
    rootEl._flMounted=true;
    opts=opts||{};
    var source=opts.source||rootEl.getAttribute('data-source')||'inline';
    var openedAt=Date.now();
    var state={weight:65,preference:0,pressure:0,usage:10,age:0,worry:0,worryText:'特になし',usageText:'デスクワーク',color:'black'};
    var recommendedTier='medium';   
    var selectedTier='medium';      
    var startedFired=false;
    var openedFired=false;
    function markAdvisorOpened(){
      if(openedFired)return;
      openedFired=true;
      openedAt=Date.now();
      fireTrack('opened',{source:source});
      fetchProduct().catch(function(){});
    }

    rootEl.innerHTML='';
    rootEl.classList.add('fl-adv-root');

    var header=mk('div','fl-adv-header',
      '<div class="fl-adv-header__badge">AI Personal Advisor</div>'+
      '<div class="fl-adv-header__title">AI硬さ診断</div>'+
      '<div class="fl-adv-header__progress" data-prog>Step 1 / 6</div>');
    rootEl.appendChild(header);
    var chat=mk('div','fl-adv-chat'); rootEl.appendChild(chat);
    var prog=header.querySelector('[data-prog]');

    var step=0;
    function askNext(){
      if(step>=QUESTIONS.length){runAnalysis();return;}
      var q=QUESTIONS[step];
      prog.textContent=(step+1)+' / '+QUESTIONS.length;
      playQuestion(chat,q,step+1,QUESTIONS.length,function(progress){
        addOptions(chat,q.options,function(pick){
          if(progress&&progress.parentNode)progress.parentNode.removeChild(progress);
          if(!startedFired){startedFired=true;fireTrack('started',{source:source});}
          if(q.scoreMode==='raw') state[q.id]=pick.value;
          else state[q.id]=pick.score;
          if(q.storeText) state[q.storeText]=pick.value;
          addUser(chat,pick.label);
          fireTrack('step',{source:source,step:step+1,question_id:q.id,answer_value:String(pick.value)});
          step++;
          setTimeout(askNext,450);
        },'question-'+q.id);
      });
    }

    function runAnalysis(){
      prog.textContent='分析中…';
      var panel=mk('div','fl-adv-analyzing',
        '<div class="fl-adv-analyzing__ring"></div>'+
        '<div class="fl-adv-analyzing__title">あなたに最適な硬さを分析しています</div>'+
        '<div class="fl-adv-analyzing__line" style="animation-delay:.2s">体格データを照合中…</div>'+
        '<div class="fl-adv-analyzing__line" style="animation-delay:.9s">使用シーンを分析中…</div>'+
        '<div class="fl-adv-analyzing__line" style="animation-delay:1.6s">最適な硬さを計算中…</div>'+
        '<div class="fl-adv-analyzing__line" style="animation-delay:2.3s">推薦パターンを確定中…</div>');
      chat.appendChild(panel); scrollBot(rootEl);
      setTimeout(function(){showResult(Date.now()-openedAt);},3000);
    }

    function showResult(dur){
      var r=calcResult(state), tier=r.tier;
      recommendedTier = tier;
      selectedTier = tier;
      var wk=state.worryText.indexOf('しびれ')!==-1?'しびれ・違和感':state.worryText.indexOf('腰')!==-1?'腰の重だるさ':state.worryText.indexOf('底付き')!==-1?'底付き・沈み込み':'default';
      var ctx=state.worryText==='特になし'?'<span>'+state.usageText+'</span> をより快適な時間にするために':'<span>'+state.usageText+'</span> での <span>'+state.worryText+'</span> を解消するために';

      chat.innerHTML=''; chat.style.setProperty('display','none','important'); prog.textContent='診断完了';
      var msgHtml=(SOLUTION[tier][wk]||SOLUTION[tier]['default'])+'<br>'+(SCENE_ADVICE[state.usageText]||SCENE_ADVICE['デスクワーク']);

      var result=mk('div','fl-adv-result',
        '<div class="fl-adv-result__top">'+
          '<div class="fl-adv-result__tag">診断結果</div>'+
          '<div class="fl-adv-result__tier">'+TIER_LABEL[tier]+'</div>'+
          '<div class="fl-adv-result__sub">'+TIER_SUB[tier]+'</div>'+
        '</div>'+
        '<div class="fl-adv-result__context"></div>'+
        '<div class="fl-adv-result__message" style="opacity:0;transition:opacity .3s"></div>');
      rootEl.appendChild(result);

      scrollToResultTop(rootEl);

      function stripHtml(h){ var d=document.createElement('div'); d.innerHTML=h.replace(/<br\s*\/?>/gi,' '); return d.textContent||''; }
      var ctxEl=result.querySelector('.fl-adv-result__context');
      var msgEl=result.querySelector('.fl-adv-result__message');
      typewriter(ctxEl, stripHtml(ctx), 22, function(){
        ctxEl.innerHTML=ctx;
        msgEl.style.opacity='1';
        setTimeout(function(){
          typewriter(msgEl, stripHtml(msgHtml), 15, function(){
            msgEl.innerHTML=msgHtml;
            
            setTimeout(startPurchaseFlow, 800);
          });
        }, 250);
      });

      fireTrack('completed',{
        source:      source,
        tier:        tier,
        total_score: r.total,
        duration_ms: dur,
        ans_weight:      state.weight,
        ans_preference:  state.preference,
        ans_pressure:    state.pressure,
        ans_usage:       state.usageText,
        ans_age:         state.age,
        ans_worry:       state.worryText
      });
    }

    
    function startPurchaseFlow(){
      
      chat.innerHTML = '';
      chat.style.removeProperty('display');
      rootEl.appendChild(chat); 
      prog.textContent = 'ご注文へのご案内';
      fireTrack('purchase_flow_start', {source:source, tier:recommendedTier});
      scene1_confirm();
    }

    
    function scene1_confirm(){
      var s = COPY.scene1_confirm;
      var lines = s.ai.map(function(l){ return t(l, {tier: TIER_LABEL[recommendedTier]}); });
      playLines(chat, lines, function(){
        var opts = s.options.map(function(o){
          return { value: o.value, label: t(o.label, {tier: TIER_LABEL[recommendedTier]}), primary: !!o.primary };
        });
        addOptions(chat, opts, function(pick){
          addUser(chat, pick.label);
          if(pick.value === 'confirm'){
            fireTrack('tier_confirmed', {source:source, tier:recommendedTier});
            selectedTier = recommendedTier;
            setTimeout(scene2_color, 450);
          } else {
            fireTrack('compare_opened', {source:source, recommended:recommendedTier});
            setTimeout(scene1b_compare, 450);
          }
        },'decision');
      });
    }

    
    function scene1b_compare(){
      var s = COPY.scene1b_compare;
      playLines(chat, s.ai, function(){
        var box = mk('div','fl-adv-tier-cards');
        ['soft','medium','hard'].forEach(function(tierKey){
          var isRec = (tierKey === recommendedTier);
          var card = mk('div', 'fl-adv-tier-card' + (isRec ? ' fl-adv-tier-card--recommended' : ''));
          card.innerHTML =
            (isRec ? '<div class="fl-adv-tier-card__badge">'+s.recommendBadge+'</div>' : '')+
            '<div class="fl-adv-tier-card__head">'+
              '<div class="fl-adv-tier-card__name">'+TIER_LABEL[tierKey]+'</div>'+
              '<div class="fl-adv-tier-card__select">'+s.btnSelect+'</div>'+
            '</div>'+
            '<div class="fl-adv-tier-card__desc">'+s.cards[tierKey].desc+'</div>';
          card.addEventListener('click', function(){
            box.style.pointerEvents = 'none';
            box.style.opacity = '.5';
            addUser(chat, TIER_LABEL[tierKey] + 'を選ぶ');
            if(tierKey === recommendedTier){
              fireTrack('tier_confirmed', {source:source, tier:tierKey, via:'compare'});
            } else {
              fireTrack('tier_changed', {source:source, from:recommendedTier, to:tierKey});
            }
            selectedTier = tierKey;
            setTimeout(scene2_color, 450);
          });
          box.appendChild(card);
        });
        chat.appendChild(box);
        scrollBot(rootEl);
      });
    }

    
    function scene2_color(){
      var s = COPY.scene2_color;
      
      state.color = 'black';
      playLines(chat, s.ai, function(){
        playLines(chat, s.afterSelect, function(){
          fireTrack('proceed_to_atc', {source:source, tier:selectedTier, color:state.color});
          setTimeout(scene4_atc, 900);
        });
      });
    }

    
    function scene4_atc(){
      var s = COPY.scene4_atc;
      chat.innerHTML = '';
      chat.style.setProperty('display','none','important');
      prog.textContent = 'ご注文内容のご確認';

      var img = IMG_BLACK;
      var final = mk('div','fl-adv-final',
        '<div class="fl-adv-final__card">'+
          '<div class="fl-adv-final__img"><img src="'+img+'" alt=""></div>'+
          '<div class="fl-adv-final__info">'+
            '<div class="fl-adv-final__tier">'+s.tierLabel+' — '+TIER_LABEL[selectedTier]+' / '+COLOR_LABEL[state.color]+'</div>'+
            '<div class="fl-adv-final__name">'+s.productName+'</div>'+
            '<div class="fl-adv-final__price" data-price>¥9,890</div>'+
            '<div class="fl-adv-final__price-note">'+s.priceNote+'</div>'+
            '<div class="_paidy-promotional-messaging fl-adv-final__paidy" data-amount="9890" data-alignment="start" data-font-size="13px" data-logo-color="white" data-currency-option="word" data-display-installment-months></div>'+
          '</div>'+
        '</div>'+
        '<button type="button" class="fl-adv-atc" data-atc>'+
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>'+
          '<span data-atc-label>'+s.btnATC+'</span>'+
        '</button>'+
        '<div class="fl-adv-atc-status" data-atc-status role="status" aria-live="polite"></div>'+
        '<button type="button" class="fl-adv-final__alt">'+s.altLink+'</button>'+
        '<div class="fl-adv-disclaimer">※ 本診断は回答データをもとに、独自アルゴリズムで最適な硬さを推薦しています。</div>');
      rootEl.appendChild(final);
      if (typeof _paidy === 'function') { _paidy('pm:refresh'); }
      scrollToResultTop(rootEl);

      var priceEl = final.querySelector('[data-price]');
      var atcBtn = final.querySelector('[data-atc]');
      var atcLabel = final.querySelector('[data-atc-label]');
      var atcStatus = final.querySelector('[data-atc-status]');
      var altBtn = final.querySelector('.fl-adv-final__alt');
      var activeVariant = null;
      var submitState = 'idle';
      var successTracked = false;
      var restoreFocusAfterError = false;

      atcBtn.disabled=true;
      atcBtn.setAttribute('aria-disabled','true');
      atcBtn.setAttribute('aria-busy','false');

      function setSubmitState(next,message,allowRetry){
        if(window.__fsvCartUncertain===true&&next!=='success'){
          next='error';
          message='追加結果を確認できませんでした。カートをご確認ください。';
          allowRetry=false;
        }
        submitState=next;
        var busy=next==='submitting';
        var canPurchase=!!(activeVariant&&activeVariant.available);
        var disabled=busy||next==='success'||!canPurchase||(next==='error'&&!allowRetry);
        atcBtn.disabled=disabled;
        atcBtn.setAttribute('aria-disabled',disabled?'true':'false');
        atcBtn.setAttribute('aria-busy',busy?'true':'false');
        atcBtn.classList.toggle('is-loading',busy);
        atcBtn.dataset.state=next;
        altBtn.disabled=busy||window.__fsvCartUncertain===true;
        if(busy)atcLabel.textContent=s.btnATCLoading;
        else if(!canPurchase&&activeVariant)atcLabel.textContent=s.btnATCSoldOut;
        else atcLabel.textContent=s.btnATC;
        atcStatus.textContent=message||'';
        atcStatus.dataset.state=message?'error':'';
        if(window.__fsvCartUncertain===true){
          var cartLink=document.createElement('a');
          cartLink.href=((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/')+'cart';
          cartLink.textContent='カートの内容を確認する';
          cartLink.style.cssText='display:block;color:inherit;text-decoration:underline;padding:12px 0;';
          atcStatus.appendChild(cartLink);
        }
        if(next==='error'&&allowRetry&&restoreFocusAfterError){
          try{atcBtn.focus({preventScroll:true});}catch(e){atcBtn.focus();}
        }
      }

      function onPageCartUncertain(){
        if(window.__fsvCartUncertain===true) setSubmitState('error','',false);
      }
      document.addEventListener('fsv:cart-uncertain',onPageCartUncertain);
      window.addEventListener('pageshow',onPageCartUncertain);

      function productFailure(){
        activeVariant=null;
        setSubmitState('error','商品情報を取得できませんでした。時間をおいて、もう一度お試しください。',false);
      }

      function applyVariant(){
        var variant=verifiedVariant(selectedTier,state.color);
        if(!variant){productFailure();return;}
        activeVariant=variant;
        var ph=fmtPrice(variant.price);
        if(variant.compare_at_price&&variant.compare_at_price>variant.price) ph+='<s style="font-size:14px!important;color:rgba(255,255,255,0.3)!important;margin-left:10px!important;text-decoration:line-through;">'+fmtPrice(variant.compare_at_price)+'</s>';
        priceEl.innerHTML=ph;
        setSubmitState('idle','',true);
      }
      if(!productCache) fetchProduct().then(function(){applyVariant();}).catch(productFailure);
      else applyVariant();

      function completeSuccess(variant){
        if(submitState==='success')return;
        setSubmitState('success','',false);
        if(!successTracked){
          successTracked=true;
          fireTrack('add_to_cart',{
            source:source,tier:selectedTier,color:state.color,
            variant_id:String(variant.id),price:variant.price/100
          });
        }
        window.location.href='/cart';
      }

      function showCartError(error,allowRetry){
        var message=error&&error.kind==='http'&&error.message
          ? error.message
          : 'カートに追加できませんでした。時間をおいて、もう一度お試しください。';
        if(error&&error.ambiguous){
          message='追加結果を確認できませんでした。カートをご確認ください。';
        }
        if(error&&error.ambiguous&&!allowRetry){
          // Monotonic page-level lock: the independent product form must not
          // offer another add after an unconfirmed advisor request (or vice versa).
          window.__fsvCartUncertain=true;
          document.dispatchEvent(new Event('fsv:cart-uncertain'));
        }
        setSubmitState('error',message,allowRetry);
      }

      function submitAdvisorCart(){
        if(window.__fsvCartUncertain===true){onPageCartUncertain();return;}
        if(submitState==='submitting'||submitState==='success')return;
        var variant=verifiedVariant(selectedTier,state.color);
        if(!variant||variant!==activeVariant){productFailure();return;}
        if(!variant.available){setSubmitState('idle','',false);return;}

        restoreFocusAfterError=document.activeElement===atcBtn;
        setSubmitState('submitting','',false);
        var baselineQuantity=null;

        readCartQuantity(variant.id).then(function(quantity){
          if(window.__fsvCartUncertain===true) throw cartAddError('page_uncertain','page_uncertain',true);
          baselineQuantity=quantity;
          return requestCartAdd(variant.id);
        }).then(function(){
          completeSuccess(variant);
        }).catch(function(error){
          if(window.__fsvCartUncertain===true){onPageCartUncertain();return;}
          if(submitState!=='submitting')return;
          if(baselineQuantity===null){
            showCartError(error||cartAddError('cart_read_failed','cart_read_failed',false),true);
            return;
          }
          if(!error||!error.ambiguous){
            showCartError(error||cartAddError('cart_add_failed','cart_add_failed',false),true);
            return;
          }
          // Lock both entry points while reconciling an ambiguous add. The
          // read may confirm success, but must never permit another POST here.
          window.__fsvCartUncertain=true;
          document.dispatchEvent(new Event('fsv:cart-uncertain'));
          readCartQuantity(variant.id).then(function(currentQuantity){
            if(currentQuantity>=baselineQuantity+1){
              completeSuccess(variant);
              return;
            }
            showCartError(error,false);
          }).catch(function(){
            showCartError(error,false);
          });
        });
      }

      atcBtn.addEventListener('click',submitAdvisorCart);

      altBtn.addEventListener('click',function(){
        if(window.__fsvCartUncertain===true||altBtn.disabled)return;
        document.removeEventListener('fsv:cart-uncertain',onPageCartUncertain);
        window.removeEventListener('pageshow',onPageCartUncertain);
        fireTrack('atc_alt_clicked', {source:source, tier:selectedTier});
        
        final.remove();
        chat.style.removeProperty('display');
        chat.innerHTML = '';
        
        rootEl.appendChild(chat);
        prog.textContent = 'ご注文へのご案内';
        scene1b_compare();
      });
    }

    prog.textContent='';
    var startPanel=mk('div','fl-adv-start',
      '<div class="fl-adv-start__icon">'+AI_SVG+'</div>'+
      (source==='inline'?'':'<div class="fl-adv-start__msg">あなたに合う硬さを<br>6つの質問から分析します</div>'+
      '<div class="fl-adv-start__note">所要時間は約30秒です</div>')+
      '<button type="button" class="fl-adv-start__btn">診断を始める →</button>');
    chat.appendChild(startPanel);
    startPanel.querySelector('.fl-adv-start__btn').addEventListener('click',function(){
      markAdvisorOpened();
      startPanel.remove();
      setTimeout(askNext,200);
    });
  }

  var q=(window.FeelaAdvisor&&window.FeelaAdvisor._queue)||[];
  window.FeelaAdvisor={mount:mount,isReady:true};
  q.forEach(function(item){mount(item[0],item[1]);});

  var root=document.getElementById('flAdvInlineRoot');
  var wrap=document.getElementById('flAdvInlineWrap');
  if(!root||!wrap)return;
  var mounted=false;
  function safeMount(){ if(mounted)return; mounted=true; root._feelaMounted=true; mount(root,{source:'inline'}); }

  if('IntersectionObserver' in window){
    var obs=new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){safeMount();obs.unobserve(wrap);} });
    },{rootMargin:'200px 0px',threshold:0.01});
    obs.observe(wrap);
  } else {
    setTimeout(safeMount,2500);
  }
})();
